import React from 'react';

import Button from '../../../../components/Button';
import RoundTextInput from '../../../../components/RoundTextInput';

import '../../styles.css';


const Component = ({
  submit,
  update,
  loading,
  error,
  children,
}) => (
  <div className="waitlist_inherit">
    { children }
    <div className="waitlist_inherit">
      <div className="waitlist_error">
        { error }
      </div>
      <RoundTextInput onChange={update}
                      placeholder="Enter your email"
                      type="email"
      />
      <Button onClick={submit} loading={loading}>
        Join waitlist
      </Button>
    </div>
  </div>
);

Component.displayName = 'Desktop';

export default Component;



// WEBPACK FOOTER //
// ./src/forms/JoinWaitlist/components/Email/Desktop.js